{
  "title": "Konnektorlar boshqaruvi",
  "refresh": "Yangilash",
  "save": "Saqlash",
  "cancel": "Bekor qilish",
  "saving": "Saqlanmoqda",
  "error": "Xatolik yuz berdi",
  "index": "T.r.",
  "every": "har {{value}}",
  "seconds_one": "{{count}} soniya",
  "seconds_other": "{{count}} soniya",
  "minutes_one": "{{count}} daqiqa",
  "minutes_other": "{{count}} daqiqa",
  "status": {
    "ok": "Ishlayapti",
    "error": "Xato",
    "off": "O'chirilgan"
  },
  "ws": {
    "idle": "Kutilmoqda",
    "connecting": "Ulanmoqda",
    "open": "Ulangan",
    "reconnecting": "Qayta ulanmoqda"
  },
  "source": {
    "title": "Jonli ma'lumot manbasi",
    "desc": "Ko'rsatkichlar qiymati qayerdan kelayotgani va manba holati",
    "name": "Manba",
    "mock": "Simulyator (sinov ma'lumotlari)",
    "unified": "ATNT yagona server",
    "state": "Holati",
    "lastSuccess": "Oxirgi muvaffaqiyatli so'rov",
    "interval": "So'rov oralig'i",
    "bound": "Bog'langan ko'rsatkichlar",
    "boundValue": "{{bound}} / {{total}}",
    "browser": "Brauzer aloqasi",
    "notConfigured": "LIVE_SOURCE=unified uchun UNIFIED_BASE_URL va UNIFIED_API_KEY sozlanmagan — qiymatlar oflayn."
  },
  "site": {
    "title": "Yagona server sayti",
    "desc": "Suv omborining yagona serverdagi sayt kodi",
    "label": "Sayt kodi",
    "placeholder": "Masalan: chotqol",
    "empty": "Sayt kodi kiritilmagan",
    "orgOnly": "Sayt kodini faqat tashkilot administratori o'zgartira oladi",
    "invalid": "Faqat kichik lotin harflari, raqamlar, «-» va «_» belgilari",
    "saved": "Sayt kodi saqlandi"
  },
  "channels": {
    "title": "Ko'rsatkichlar kanallari",
    "desc": "Fizik ko'rsatkichni yagona server kanaliga bog'lang: kanalni tanlang yoki yozing, Enter bosing.",
    "readOnly": "Kanallarni o'zgartirish uchun «Konnektorlar» bo'limini tahrirlash huquqi kerak.",
    "search": "Qurilma yoki ko'rsatkich bo'yicha izlash",
    "device": "Qurilma",
    "indicator": "Ko'rsatkich",
    "channel": "Kanal",
    "binding": "Bog'lanish",
    "value": "Oxirgi qiymat",
    "time": "O'lchov vaqti",
    "status": "Holat",
    "none": "Bog'lanmagan",
    "bound": "Bog'langan",
    "unknown": "Noma'lum kanal",
    "placeholder": "Kanalni tanlang",
    "saved": "Kanal saqlandi",
    "empty": "Fizik ko'rsatkichlar mavjud emas"
  },
  "help": {
    "title": "Qanday ishlaydi?",
    "items": [
      "Yagona server suv omborlaridagi agentlar yuborgan CSV fayllardan har bir sayt uchun 4 ta hisoblangan ko'rsatkichni beradi: LEVEL (suv sathi), VOLUME (suv hajmi), INFLOW (kelayotgan suv) va DISCHARGE (chiqarilayotgan suv).",
      "Suv omborini bog'lash uchun uning sayt kodini kiriting (masalan, chotqol), so'ng fizik ko'rsatkichlarga kanal tanlang: hydro:LEVEL, hydro:VOLUME, hydro:INFLOW yoki hydro:DISCHARGE.",
      "Serverdagi ma'lumot soatiga bir marta yangilanadi, konnektor uni har 5 daqiqada so'raydi. 3 soatdan eski qiymat «Ma'lumot yo'q» deb ko'rsatiladi.",
      "Faqat «ok» holatidagi qiymatlar qabul qilinadi; boshqa holatlarda ko'rsatkich oflayn bo'ladi va mezon tekshirilmaydi."
    ]
  },
  "statuses": {
    "connected": "Ulangan",
    "error": "Xatolik",
    "disabled": "O'chirilgan",
    "checking": "Tekshirilmoqda"
  },
  "scopes": {
    "organization": "Tashkilot",
    "tenant": "Suv ombori"
  },
  "time": {
    "never": "Hali bo'lmagan",
    "justNow": "Hozirgina",
    "minutes_one": "{{count}} daqiqa oldin",
    "minutes_other": "{{count}} daqiqa oldin",
    "hours_one": "{{count}} soat oldin",
    "hours_other": "{{count}} soat oldin",
    "days_one": "{{count}} kun oldin",
    "days_other": "{{count}} kun oldin"
  },
  "types": {
    "atnt_unified": {
      "name": "ATNT Yagona server",
      "desc": "6 ta suv omborining datchiklari va gidro ko'rsatkichlari bitta serverda",
      "help": "Yagona server suv omborlaridagi agentlar yuborgan CSV fayllardan datchiklarning oxirgi qiymatini va 4 ta gidro ko'rsatkichni beradi."
    },
    "rest": {
      "name": "REST API",
      "desc": "O'z backendingizdan HTTP orqali datchiklar ro'yxati va qiymatlarini so'rash",
      "help": "Konnektor belgilangan oraliqda datchiklar ro'yxatini va oxirgi qiymatlarni HTTP GET orqali so'raydi. JSONPath maydonlari javobdagi identifikator, qiymat va vaqtni ko'rsatadi."
    },
    "mqtt": {
      "name": "MQTT broker",
      "desc": "Datchiklar xabarlarini MQTT mavzularidan real vaqtda qabul qilish",
      "help": "Konnektor brokerga obuna bo'ladi va mavzu filtriga mos keladigan har bir mavzuni alohida datchik sifatida qabul qiladi (JSON, CSV yoki oddiy son)."
    },
    "opcua": {
      "name": "OPC UA",
      "desc": "SCADA va PLC tizimlaridagi OPC UA tugunlarini o'qish",
      "help": "Konnektor OPC UA serverga ulanib, ko'rsatilgan tugunlar (NodeId) qiymatini belgilangan oraliqda o'qiydi. Har bir tugun — bitta datchik."
    },
    "modbus_tcp": {
      "name": "Modbus TCP",
      "desc": "Kontrollerlar registrlarini Modbus TCP orqali so'rash",
      "help": "Konnektor Modbus TCP qurilmasidan (IP, port, unit ID) ro'yxatdagi registrlarni o'qiydi va masshtab koeffitsiyentini qo'llaydi. Har bir registr — bitta datchik."
    },
    "webhook": {
      "name": "Webhook",
      "desc": "Tashqi tizim ma'lumotlarni o'zi yuboradi (HTTP POST)",
      "help": "Tashqi tizim qiymatlarni berilgan URL manziliga POST qiladi va har bir so'rovni maxfiy kalit bilan imzolaydi (X-Signature, HMAC-SHA256). Datchiklar birinchi ma'lumot kelganda paydo bo'ladi."
    },
    "file_import": {
      "name": "Fayl importi (CSV / Excel)",
      "desc": "Logger fayllarini qo'lda yoki jadval bo'yicha yuklash",
      "help": "Har bir yuklangan fayl ustunlar xaritasiga ko'ra o'qiladi: vaqt ustuni va har bir ma'lumot ustuni alohida datchik bo'ladi."
    }
  },
  "list": {
    "title": "Konnektorlar",
    "create": "Konnektor qo'shish",
    "search": "Nomi, turi yoki manzil bo'yicha izlash",
    "typeFilter": "Turi bo'yicha saralash",
    "allTypes": "Barcha turlar",
    "statusFilter": "Holati bo'yicha saralash",
    "allStatuses": "Barcha holatlar",
    "name": "Konnektor",
    "type": "Turi",
    "scope": "Qamrov",
    "status": "Holati",
    "sensors": "Datchiklar",
    "lastSync": "Oxirgi sinxronlash",
    "empty": "Konnektorlar hali qo'shilmagan",
    "emptyHint": "Datchiklar va ularning qiymatlari keladigan manbani ulang."
  },
  "table": {
    "actions": "Harakat",
    "actionsLabel": "Amallar"
  },
  "menu": {
    "open": "Ochish",
    "test": "Tekshirish",
    "enable": "Yoqish",
    "disable": "O'chirib qo'yish",
    "edit": "Tahrirlash",
    "delete": "O'chirish",
    "enabled": "Konnektor yoqildi",
    "disabled": "Konnektor o'chirib qo'yildi",
    "deleteTitle": "Konnektorni o'chirish",
    "deleteText": "«{{name}}» konnektori o'chiriladi. Bog'langan ko'rsatkichlar qiymat olishni to'xtatadi.",
    "deleteOrgText": "«{{name}}» tashkilot konnektori barcha suv omborlari uchun o'chiriladi. Bog'langan ko'rsatkichlar qiymat olishni to'xtatadi.",
    "deleted": "Konnektor o'chirildi"
  },
  "test": {
    "run": "Ulanishni tekshirish",
    "running": "Tekshirilmoqda…",
    "ok": "Ulanish muvaffaqiyatli",
    "failed": "Ulanib bo'lmadi",
    "latency": "{{ms}} ms",
    "sensors_one": "{{count}} ta datchik topildi",
    "sensors_other": "{{count}} ta datchik topildi"
  },
  "panel": {
    "back": "Ortga qaytish",
    "createTitle": "Konnektor qo'shish",
    "editTitle": "Konnektorni tahrirlash",
    "stepType": "Manba turi",
    "stepSettings": "Sozlamalar",
    "pickHint": "Datchiklar qayerdan kelishini tanlang.",
    "changeType": "Turini o'zgartirish",
    "connected": "Ulangan",
    "soon": "Tez orada",
    "saved": "O'zgarishlar saqlandi",
    "created": "Konnektor qo'shildi"
  },
  "common": {
    "unsavedTitle": "O'zgarishlar saqlanmagan",
    "unsavedText": "Kiritilgan ma'lumotlar yo'qoladi.",
    "stay": "Qolish",
    "leave": "Chiqish"
  },
  "form": {
    "name": "Konnektor nomi",
    "namePlaceholder": "Masalan: Pudratchi telemetriya API",
    "description": "Tavsif",
    "descriptionPlaceholder": "Qisqacha izoh (ixtiyoriy)",
    "scope": "Qamrov",
    "scopeHint": "Tashkilot konnektori tashkilotning barcha suv omborlarida ko'rinadi.",
    "scopeOrgOnly": "Tashkilot konnektorini faqat tashkilot administratori qo'sha oladi.",
    "scopeFixed": "Qamrov yaratilgandan so'ng o'zgarmaydi.",
    "connection": "Ulanish",
    "enabled": "Konnektor yoqilgan",
    "pollInterval": "So'rov oralig'i",
    "pollHint": "10 soniyadan 24 soatgacha",
    "sec": "soniya",
    "secretStored": "Saqlangan: {{hint}} — almashtirish uchun yangisini kiriting",
    "secretPlaceholder": "Maxfiy qiymatni kiriting",
    "show": "Ko'rsatish",
    "hide": "Yashirish",
    "copy": "Nusxa olish",
    "copied": "Nusxa olindi",
    "copyFailed": "Nusxa olib bo'lmadi",
    "regenerate": "Yangi kalit yaratish",
    "baseUrl": "Server manzili (URL)",
    "baseUrlHint": "/api prefiksi bilan, masalan https://monitoring.uzgidro.uz/api",
    "apiKey": "API kaliti (X-API-Key)",
    "apiKeyHint": "Yagona serverdagi «Tashqi tizim kalitlari» bo'limida beriladi; faqat bir marta ko'rsatiladi.",
    "siteCode": "Sayt kodi",
    "siteCodeHint": "Har bir suv ombori uchun alohida — «Yagona server sayti» kartasida o'zgartiriladi.",
    "siteCodeEmpty": "Kiritilmagan",
    "auth": "Autentifikatsiya",
    "authKinds": {
      "none": "Yo'q",
      "header": "Sarlavha kaliti",
      "bearer": "Bearer token"
    },
    "headerName": "Sarlavha nomi",
    "headerValue": "Kalit qiymati",
    "token": "Token",
    "sensorsPath": "Datchiklar yo'li",
    "valuesPath": "Qiymatlar yo'li",
    "idPath": "ID (JSONPath)",
    "valuePath": "Qiymat (JSONPath)",
    "timePath": "Vaqt (JSONPath)",
    "brokerUrl": "Broker manzili",
    "brokerHint": "mqtt://, mqtts://, ws:// yoki wss://",
    "topic": "Mavzu filtri",
    "topicHint": "+ — bitta daraja, # — qolgan barcha darajalar",
    "username": "Foydalanuvchi",
    "password": "Parol",
    "payloadFormat": "Xabar formati",
    "endpointUrl": "Endpoint manzili",
    "securityMode": "Xavfsizlik rejimi",
    "security": {
      "none": "Yo'q (None)",
      "sign": "Imzo (Sign)",
      "sign_encrypt": "Imzo va shifrlash"
    },
    "nodeIds": "Tugunlar (NodeId)",
    "nodeIdsHint": "Har bir qatorda bitta NodeId",
    "host": "Xost (IP yoki nom)",
    "port": "Port",
    "unitId": "Unit ID",
    "registers": "Registrlar",
    "addRegister": "Registr qo'shish",
    "registerName": "Registr nomi",
    "address": "Manzil",
    "removeRegister": "Registrni o'chirish",
    "registerKind": "Registr turi",
    "registerKinds": {
      "holding": "Holding",
      "input": "Input",
      "coil": "Coil",
      "discrete": "Discrete"
    },
    "dataType": "Ma'lumot turi",
    "scale": "Masshtab",
    "unit": "Birlik",
    "webhookUrl": "Webhook manzili",
    "webhookUrlHint": "Tashqi tizim qiymatlarni shu manzilga POST qiladi.",
    "webhookSecret": "Maxfiy kalit",
    "webhookSecretOnce": "Kalitdan hozir nusxa oling — saqlangandan so'ng to'liq ko'rsatilmaydi.",
    "webhookSecretHint": "Kalit saqlangan. Yangisini yaratsangiz, eskisi saqlangandan so'ng bekor bo'ladi.",
    "fileFormat": "Fayl formati",
    "delimiter": "Ajratuvchi",
    "delimiters": {
      "comma": "Vergul ( , )",
      "semicolon": "Nuqtali vergul ( ; )",
      "tab": "Tabulyatsiya"
    },
    "timeColumn": "Vaqt ustuni",
    "timeFormat": "Vaqt formati",
    "headerRow": "Sarlavha qatori",
    "decimal": "Kasr ajratuvchi",
    "columns": "Ma'lumot ustunlari",
    "columnsHint": "Har bir qatorda bitta ustun: «Ustun nomi | birlik»"
  },
  "errors": {
    "required": "To'ldirish majburiy",
    "url": "To'g'ri manzil kiriting",
    "interval": "10 dan 86400 gacha butun son",
    "header": "Faqat lotin harflari, raqamlar va «-»",
    "path": "«/» bilan boshlanuvchi yo'l",
    "jsonPath": "«$» bilan boshlanuvchi JSONPath",
    "host": "IP manzil yoki xost nomi",
    "port": "1 dan 65535 gacha",
    "unitId": "0 dan 255 gacha",
    "nodeIds": "Kamida bitta NodeId kiriting",
    "columns": "Kamida bitta ustun kiriting",
    "registers": "Kamida bitta registr kerak",
    "number": "Musbat butun son",
    "secret": "Maxfiy qiymatni kiriting",
    "address": "0–65535",
    "invalid": "Noto'g'ri qiymat"
  },
  "detail": {
    "notFound": "Konnektor topilmadi",
    "notFoundHint": "U o'chirilgan yoki sizda unga kirish huquqi yo'q.",
    "back": "Konnektorlarga qaytish",
    "tabsLabel": "Konnektor bo'limlari",
    "tabs": {
      "overview": "Umumiy",
      "sensors": "Datchiklar",
      "channels": "Kanallar",
      "settings": "Sozlamalar",
      "log": "Jurnal"
    }
  },
  "overview": {
    "status": "Holat",
    "statusDesc": "Manbaga ulanish va oxirgi sinxronlash",
    "state": "Holati",
    "lastSync": "Oxirgi sinxronlash",
    "interval": "So'rov oralig'i",
    "push": "Manba o'zi yuboradi",
    "bound": "Bog'langan datchiklar",
    "enabled": "Yoqilgan",
    "yes": "Ha",
    "no": "Yo'q",
    "type": "Turi",
    "notSet": "Kiritilmagan",
    "createdAt": "Yaratilgan vaqti",
    "createdBy": "Qo'shgan xodim",
    "system": "Tizim",
    "source": "Manba",
    "sourceDesc": "Ma'lumotlar qayerdan va qanday olinadi",
    "nodes": "Tugunlar bo'yicha datchiklar",
    "nodesDesc_one": "{{count}} ta tugun (qurilma / shlyuz) · bog'langan / jami",
    "nodesDesc_other": "{{count}} ta tugun (qurilma / shlyuz) · bog'langan / jami",
    "all": "Barchasi",
    "recent": "So'nggi hodisalar",
    "recentDesc": "Sinxronlash, tekshiruv va o'zgarishlar"
  },
  "sensors": {
    "hydroNode": "Hisoblangan gidro ko'rsatkichlar",
    "empty": "Datchiklar hali topilmadi",
    "emptyHint": "Manbadan birinchi ma'lumot kelgach, datchiklar shu yerda paydo bo'ladi.",
    "search": "Ustun, tugun yoki ko'rsatkich bo'yicha izlash",
    "filter": "Bog'lanish bo'yicha saralash",
    "all": "Barchasi",
    "bound": "Bog'langan",
    "unbound": "Bog'lanmagan",
    "column": "Datchik (ustun)",
    "channel": "Kanal",
    "value": "Oxirgi qiymat",
    "time": "O'lchov vaqti",
    "binding": "Bog'langan ko'rsatkich",
    "notBound": "Bog'lanmagan",
    "bindPlaceholder": "Ko'rsatkichni tanlang",
    "unbind": "Bog'lanishni uzish",
    "boundToast": "Datchik bog'landi",
    "unboundToast": "Bog'lanish uzildi",
    "import": "Qurilma sifatida import qilish",
    "importN_one": "Qurilma sifatida import qilish ({{count}})",
    "importN_other": "Qurilma sifatida import qilish ({{count}})",
    "imported_one": "{{devices}} ta qurilma va {{count}} ta ko'rsatkich import qilindi",
    "imported_other": "{{devices}} ta qurilma va {{count}} ta ko'rsatkich import qilindi",
    "importMock": "Sinov rejimi: qurilmalar backend tayyor bo'lgach yaratiladi",
    "type": "Signal turi"
  },
  "log": {
    "time": "Vaqt",
    "level": "Daraja",
    "message": "Xabar",
    "search": "Xabar bo'yicha izlash",
    "all": "Barchasi",
    "empty": "Jurnal bo'sh",
    "levels": {
      "info": "Ma'lumot",
      "warning": "Ogohlantirish",
      "error": "Xatolik"
    },
    "codes": {
      "sync": {
        "ok": "Sinxronlash yakunlandi: {{sensors}} ta datchik, {{ms}} ms"
      },
      "sensors": {
        "stale": "{{count}} ta datchik 3 soatdan beri yangilanmagan",
        "imported": "Import so'raldi: {{devices}} ta qurilma, {{sensors}} ta datchik (sinov rejimi)"
      },
      "source": {
        "timeout": "Manba {{ms}} ms ichida javob bermadi",
        "retry": "{{sec}} soniyadan so'ng qayta urinish"
      },
      "auth": {
        "failed": "Avtorizatsiya rad etildi (HTTP {{status}})"
      },
      "test": {
        "ok": "Ulanish tekshiruvi muvaffaqiyatli: {{ms}} ms, {{sensors}} ta datchik",
        "failed": "Ulanish tekshiruvi muvaffaqiyatsiz: {{error}}"
      },
      "connector": {
        "created": "Konnektor yaratildi",
        "updated": "Sozlamalar o'zgartirildi",
        "enabled": "Konnektor yoqildi",
        "disabled": "Konnektor o'chirildi"
      },
      "sensor": {
        "bound": "{{column}} → {{indicator}} bog'landi",
        "unbound": "{{column}} bog'lanishi uzildi"
      }
    }
  },
  "settings": {
    "title": "Ulanish sozlamalari",
    "desc": "Manba manzili, kirish ma'lumotlari va so'rov oralig'i",
    "orgOnly": "Bu tashkilot konnektori — uni faqat tashkilot administratori o'zgartira oladi.",
    "readOnly": "Konnektorni o'zgartirish uchun «Konnektorlar» bo'limini tahrirlash huquqi kerak."
  }
}
